import { render, staticRenderFns } from "./import-from-campaign.vue?vue&type=template&id=1a12c098&scoped=true"
import script from "./import-from-campaign.vue?vue&type=script&lang=js"
export * from "./import-from-campaign.vue?vue&type=script&lang=js"
import style0 from "./import-from-campaign.vue?vue&type=style&index=0&id=1a12c098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12c098",
  null
  
)

export default component.exports